import layoutMain from 'app/fuse-layouts/layout-main/LayoutMain'

const FuseLayouts = {
  layoutMain,
}

export default FuseLayouts
